var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrops(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "menu-svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.054 0C10.962 1.908 11.979 4.356 12.141 6.867C10.989 7.488 9.927 8.28 9 9.234C8.073 8.271 7.011 7.479 5.859 6.867C6.066 4.374 7.128 1.926 9.054 0ZM6.24004 9.21666C6.24245 9.21829 6.24471 9.22013 6.24711 9.22176C6.20082 9.19091 6.15262 9.1617 6.10376 9.13208C6.03132 9.08817 5.9574 9.04336 5.886 8.991C5.94265 9.02877 6.00088 9.06495 6.05871 9.10087C6.0787 9.11329 6.09864 9.12568 6.11845 9.1381C6.1598 9.16401 6.20059 9.19004 6.24004 9.21666Z",
    fill: "#828282"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "menu-svg",
    d: "M0 7.2C0 11.988 3.024 16.038 7.227 17.541C7.794 17.748 8.388 17.901 9 18C9.612 17.892 10.197 17.739 10.773 17.541C14.976 16.038 18 11.988 18 7.2C14.238 7.2 10.935 9.153 9 12.105C8.26374 10.9818 7.32941 10.0032 6.24711 9.22176C6.20082 9.19091 6.15262 9.1617 6.10376 9.13208C6.03132 9.08817 5.9574 9.04336 5.886 8.991C5.94265 9.02877 6.00088 9.06495 6.05871 9.10087L6.11845 9.1381C6.1598 9.16401 6.20059 9.19004 6.24004 9.21666C4.47921 7.94752 2.32745 7.2 0 7.2Z",
    fill: "#828282"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrops);
export default __webpack_public_path__ + "static/media/Crops.bd787fdb.svg";
export { ForwardRef as ReactComponent };